export const GALLERY_TAB_TYPE = {
    exterior: "exterior",
    interior: "interior",
    imperfections: "imperfections",
    allImages: "allImages",
    threeSixtyViewUrl: "threeSixtyViewUrl",
    threeSixtyView: "threeSixtyView"
};
